import axios from "axios";
import {variables} from "../Variables.json";
import convertFileToWebP from "./convertFileToWebP";
import servicesApi from "../seller-apis/servicesApi";
import { GenUtilities } from "./GenUtilities";

const allowedImageExtensions = [".png", ".jpg", ".jpeg"];

export const uploadImage = async (file, vendorId = null) => {
  try {
    const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

    // Check file extension
    if (!allowedImageExtensions.includes(fileExtension)) {
      throw new Error("Only PNG, JPG, and JPEG images are allowed.");
    }

    // Check file size limit
    if (file.size > variables.limit.SellerSupport.image) {
      throw new Error("A max size of 2 MB image can be uploaded");
    }

    // Convert file to WebP
    const convertedImg = await convertFileToWebP(file);
    const originalBlob = convertedImg;
    const strArray = convertedImg.name.split(".");
    const newName = strArray[0] + "-" + new Date().getTime() + "." + strArray[1];
    const renamedFile = new File([originalBlob], newName, { type: convertedImg.type });

    const formdata = new FormData();
    formdata.append("file", renamedFile);

    const imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + newName);
    const data = { imageName: "seller/support/" + imageFinal };

    // Get the upload URL
    const res = await servicesApi.getUploadUrl(data);

    // Upload the file to the URL
    const uploadRes = await axios({
      method: "post",
      url: res.data,
      data: formdata,
      onUploadProgress: (data) => {
        //  handle progress here
      },
    });

    return { msg: "success", url: uploadRes?.data?.result?.variants[0], fileType: "image" };
  } catch (error) {
    throw error; 
  }
};